module.exports = __webpack_public_path__ + "static/eval4-52ecea064cb387aec9c289b9b06e1fae.pdf";